(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // ============================================
  // REMOVE BADGES FROM MOBILE MENU DRAWER
  // ============================================
  function removeBadgesFromMenuDrawer() {
    if (window.innerWidth <= 989) {
      var menuDrawer = document.querySelector('.menu-drawer');
      if (menuDrawer) {
        var badges = menuDrawer.querySelectorAll('.badge, [id*="Badge"], [id*="SaleBadge"], [id*="NewBadge"], [id*="SoldOutBadge"], .card__badge');
        badges.forEach(function(badge) {
          if (badge) {
            badge.remove();
          }
        });
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(removeBadgesFromMenuDrawer, 500);
  });
  
  var drawerToggle = document.querySelector('header-drawer');
  if (drawerToggle) {
    drawerToggle.addEventListener('click', function() {
      setTimeout(removeBadgesFromMenuDrawer, 300);
    });
  }
  
  document.addEventListener('shopify:section:load', function() {
    setTimeout(removeBadgesFromMenuDrawer, 500);
  });
  
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        removeBadgesFromMenuDrawer();
      }
    });
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    var menuDrawer = document.querySelector('.menu-drawer');
    if (menuDrawer) {
      observer.observe(menuDrawer, { childList: true, subtree: true });
    }
  });

  // ============================================
  // HANDLE CLICK ON SUMMARY WITH DATA-URL
  // Navigate to the URL when clicking the text area (not the caret)
  // ============================================
  document.addEventListener('click', function(e) {
    var summary = e.target.closest('summary[data-url]');
    if (summary) {
      var details = summary.closest('details');
      if (details) {
        var isOpen = details.hasAttribute('open');
        var caret = summary.querySelector('.icon-caret');
        
        // Check if click was on the caret or the text
        if (caret && caret.contains(e.target)) {
          // Click on caret - let default toggle behavior happen
          return;
        }
        
        // Click on text area
        if (isOpen) {
          // If menu is already open, navigate to the URL
          window.location.href = summary.getAttribute('data-url');
        }
        // If menu is closed, let default toggle behavior happen
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
